module.exports = __webpack_public_path__ + "static/media/termopary4ru.33918ceb.pdf";